import Unread from 'entities/Unread';
import Collection from 'lib/Collection';

class Unreads extends Collection<Unread> {
  initialize() {
    // $FlowIssue
    this.url = '/notifications/unread';
    // @ts-expect-error ts-migrate(2740) FIXME: Type 'typeof Unread' is missing the following prop... Remove this comment to see the full error message
    this.model = Unread;
  }

  parse(response: any) {
    if (response.unreads) {
      return response.unreads.concat(response['group_unreads'] || []);
    }
    return [];
  }
}

export default Unreads;
